//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
SPLM.Annotations.TextPreferencesOption = Object.freeze({
    "PartLettering" : "PartLettering", "MasterSymbol" : "MasterSymbol", "Last" : "Last"});

SPLM.Annotations.SymbolPreferencesOption = Object.freeze({
    "PartSymbol" : "PartSymbol", "MasterSymbol" : "MasterSymbol", "Last" : "Last"});

SPLM.Annotations.FlipOption = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical", "Last" : "Last"});

SPLM.Annotations.TextType = Object.freeze({
    "Mandatory" : "Mandatory", "Arbitrary" : "Arbitrary", "Controlled" : "Controlled", "PartiallyControlled" : "PartiallyControlled", "Integer" : "Integer", "Real" : "Real", "Last" : "Last"});

export default SPLM;